import { render } from "./TipsPage.vue?vue&type=template&id=3af0c686&scoped=true"
import script from "./TipsPage.vue?vue&type=script&lang=js"
export * from "./TipsPage.vue?vue&type=script&lang=js"

import "./TipsPage.vue?vue&type=style&index=0&id=3af0c686&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af0c686"]])

export default __exports__